























































import { Component, Vue } from "vue-property-decorator";
import { apiConfigService } from "../config/api.config";
import { responseHandler } from "../shared/helpers";
import { WalletModel } from "../models/Wallet";
import { TransactionModel } from "../models/Transaction";
import { TransactionUtils } from "../utils/transaction.util";
import { appStore } from "../store/stores";
import { authenticationStore } from "../api/authentication/authentication.module";

@Component
export default class WalletScreen extends Vue {
  wallet: Partial<WalletModel> = {
    balance: 0
  };

  transactions: TransactionModel[] = [];

  util = TransactionUtils;

  get configuration() {
    return appStore.configuration;
  }

  get user() {
    return authenticationStore.user;
  }

  async mounted() {
    Promise.all([this.getWallet(), this.getTransactions()]);
  }

  async getWallet() {
    try {
      this.showLoading();
      const response = await apiConfigService.request().get("/wallets/my-wallet");
      const result = responseHandler(response);
      this.wallet = result.data;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.hideLoading();
    }
  }

  async getTransactions() {
    try {
      this.showLoading();
      const response = await apiConfigService.request().get("/transactions/my-transactions");
      const result = responseHandler(response);
      this.transactions = result.data;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.hideLoading();
    }
  }

  handleReferral() {
    const message = "Hey, use Soundhalla to get your songs heard by real fans on Spotify, YouTube & more. Join with my referral code {referralCode}".replace(
      "{referralCode}",
      this.user.referralCode
    );
    navigator.clipboard.writeText(message);
    this.toastSuccess("Text copied");
  }
}
